import React from "react";
import { HiOutlineChevronUp, HiOutlineChevronDown } from "react-icons/hi2";

const TimesheetResizeTray = ({ onMouseDown }) => {
  return (
    <div
      className="group relative z-10 flex h-7 shrink-0 cursor-row-resize select-none items-center justify-center"
      onMouseDown={onMouseDown}
      title="Drag to resize workspace"
      style={{ userSelect: "none" }}
    >
      <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-[#E5E7EB]" />
      <div
        className="relative flex items-center gap-1 rounded-full border border-[#E5E7EB] bg-white px-2.5 py-0.5 text-[#94A3B8] shadow-sm transition-colors group-hover:border-[#C5D4EA] group-hover:text-[#4A6BB6]"
      >
        <HiOutlineChevronUp className="h-3 w-3" />
        <div className="flex flex-col gap-0.5 py-0.5">
          <span className="block h-0.5 w-3 rounded-full bg-current" />
          <span className="block h-0.5 w-3 rounded-full bg-current" />
        </div>
        <HiOutlineChevronDown className="h-3 w-3" />
      </div>
    </div>
  );
};

export default TimesheetResizeTray;
